import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import srLatn from 'vuetify/es5/locale/sr-Latn';
import en from 'vuetify/es5/locale/en';
import hr from 'vuetify/es5/locale/hr';
import fr from 'vuetify/es5/locale/fr';
const appHolder = document.getElementById('app');
var themeOptions = JSON.parse(appHolder.dataset.page).props.organization.themeOptions;
Vue.use(Vuetify);

const opts = {
    lang: {
        locales: { srLatn, en, hr,fr },
        current: 'srLatn',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: themeOptions.primary,
                darker: '#612566',
                lighter: '#ae1a5f',
                muted: '#eeeeee',
                redHover: '#EF5350'
            },
            dark: {

            }
        },
        customProperties: true
    },
    treeShake: true
};

export default new Vuetify(opts);
